export default "__VITE_ASSET__CnHsmN2m__"